import apiClient from '../axios.js';

const BASE = '/client/commerce';

export const commerceSettingsApi = {
  listContentCategories: () => apiClient.get(`${BASE}/content-categories`),
  /**
   * 取得商城設定（結帳模式、點數、GTM/GA4 等）
   */
  getSettings: () => {
    return apiClient.get(`${BASE}/settings`);
  },

  /**
   * 部分更新商城設定
   * @param {Object} patch
   */
  updateSettings: (patch) => {
    return apiClient.patch(`${BASE}/settings`, patch);
  },

  /**
   * 列出金流 provider 設定
   */
  listPaymentProviders: () => {
    return apiClient.get(`${BASE}/integration-providers`, { params: { channel: 'payment' } });
  },

  /**
   * 新增或更新單一 provider
   * @param {Object} provider - { provider_code, display_order, is_enabled, is_sandbox, credentials }
   */
  upsertPaymentProvider: (provider) => {
    return apiClient.put(`${BASE}/integration-providers`, { ...provider, channel: 'payment' });
  },

  /**
   * 刪除金流 provider（依 provider_code）
   * @param {string} providerCode
   */
  deletePaymentProvider: (providerCode) => {
    return apiClient.delete(`${BASE}/integration-providers/payment/${encodeURIComponent(providerCode)}`);
  },

  listIntegrationProviders: (channel) =>
    apiClient.get(`${BASE}/integration-providers`, {
      params: channel ? { channel } : {}
    }),
  upsertIntegrationProvider: (provider) => apiClient.put(`${BASE}/integration-providers`, provider),
  deleteIntegrationProvider: (channel, providerCode) =>
    apiClient.delete(`${BASE}/integration-providers/${encodeURIComponent(channel)}/${encodeURIComponent(providerCode)}`),

  listShippingRules: (params) => apiClient.get(`${BASE}/shipping-rules`, { params }),
  createShippingRule: (body) => apiClient.post(`${BASE}/shipping-rules`, body),
  updateShippingRule: (id, body) => apiClient.patch(`${BASE}/shipping-rules/${id}`, body),
  deleteShippingRule: (id) => apiClient.delete(`${BASE}/shipping-rules/${id}`),
  resetEcpayShippingRules: () => apiClient.post(`${BASE}/shipping-rules/ecpay-reset`),
  reorderShippingRules: (body) => apiClient.post(`${BASE}/shipping-rules/reorder`, body),

  listPromotionRules: () => apiClient.get(`${BASE}/promotion-rules`),
  createPromotionRule: (body) => apiClient.post(`${BASE}/promotion-rules`, body),
  updatePromotionRule: (id, body) => apiClient.patch(`${BASE}/promotion-rules/${id}`, body),
  deletePromotionRule: (id) => apiClient.delete(`${BASE}/promotion-rules/${id}`),

  listB2bTierPrices: (params) => apiClient.get(`${BASE}/b2b-tier-prices`, { params }),
  upsertB2bTierPrice: (body) => apiClient.put(`${BASE}/b2b-tier-prices`, body),
  deleteB2bTierPrice: (id) => apiClient.delete(`${BASE}/b2b-tier-prices/${id}`),

  listMemberTierCredits: () => apiClient.get(`${BASE}/member-tier-credits`),
  upsertMemberTierCredit: (body) => apiClient.put(`${BASE}/member-tier-credits`, body),
  deleteMemberTierCredit: (id) => apiClient.delete(`${BASE}/member-tier-credits/${id}`),

  // 館別（halls）
  listHalls: () => apiClient.get(`${BASE}/halls`),
  getHall: (id) => apiClient.get(`${BASE}/halls/${id}`),
  createHall: (body) => apiClient.post(`${BASE}/halls`, body),
  updateHall: (id, body) => apiClient.patch(`${BASE}/halls/${id}`, body),
  deleteHall: (id) => apiClient.delete(`${BASE}/halls/${id}`),
  getHallProducts: (id) => apiClient.get(`${BASE}/halls/${id}/products`),
  updateHallProducts: (id, products) => apiClient.put(`${BASE}/halls/${id}/products`, { products }),

  // Banner
  listBanners: (placement) => apiClient.get(`${BASE}/banners`, { params: placement ? { placement } : {} }),
  getBanner: (id) => apiClient.get(`${BASE}/banners/${encodeURIComponent(id)}`),
  createBanner: (body) => apiClient.post(`${BASE}/banners`, body),
  updateBanner: (id, body) => apiClient.patch(`${BASE}/banners/${id}`, body),
  deleteBanner: (id) => apiClient.delete(`${BASE}/banners/${id}`),

  // CMS 頁面（storefront pages）
  listPages: () => apiClient.get(`${BASE}/pages`),
  getPage: (slug) => apiClient.get(`${BASE}/pages/${encodeURIComponent(slug)}`),
  createPage: (body) => apiClient.post(`${BASE}/pages`, body),
  updatePage: (slug, body) => apiClient.patch(`${BASE}/pages/${encodeURIComponent(slug)}`, body),
  deletePage: (slug) => apiClient.delete(`${BASE}/pages/${encodeURIComponent(slug)}`),
};
